import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import FilterForm from "./FilterForm";

import {
  handleChangeAll as handleChangeAllAction,
  handleChangeToInitState as handleChangeToInitStateAction,
} from "../../../actions/handleChangeAction";
import { getMiljogebyrTilBehandling as getMiljogebyrTilBehandlingAction } from "../../../actions/miljogebyrTilBehandlingActions";
import { getMiljoleveringstyper as getMiljoleveringstyperAction } from "../../../actions/miljoleveringstyperActions";
import { getOvertredelseskoderMiljogebyr as getOvertredelseskoderMiljogebyrAction } from "../../../actions/overtredelseskoderMiljogebyrActions";

import { getOvertredelseskoder } from "../../../selectors/miljogebyrTilBehandlingSelector";

export default function FilterFormContainer() {
  const dispatch = useDispatch();

  const miljogebyrTilBehandling = useSelector(
    (state) => state.miljogebyrTilBehandling,
  );
  const leveringstyper = useSelector((state) => state.miljoleveringstyper);
  const overtredelseskoder = useSelector(getOvertredelseskoder);
  const getMiljogebyrTilBehandling = useCallback(
    (params) =>
      dispatch(
        getMiljogebyrTilBehandlingAction(
          params,
          miljogebyrTilBehandling.page,
          miljogebyrTilBehandling.count,
        ),
      ),
    [dispatch, miljogebyrTilBehandling],
  );
  const getOvertredelseskoderMiljogebyr = useCallback(
    () => dispatch(getOvertredelseskoderMiljogebyrAction()),
    [dispatch],
  );
  const getMiljoleveringstyper = useCallback(
    () => dispatch(getMiljoleveringstyperAction()),
    [dispatch],
  );
  const handleChangeAll = useCallback(
    (payload) =>
      dispatch(
        handleChangeAllAction(
          "MILJOGEBYRER_TIL_BEHANDLING_FILTER_FORM",
          payload,
        ),
      ),
    [dispatch],
  );

  return (
    <FilterForm
      overtredelseskoder={overtredelseskoder}
      leveringstyper={leveringstyper}
      getMiljogebyrTilBehandling={getMiljogebyrTilBehandling}
      getOvertredelseskoderMiljogebyr={getOvertredelseskoderMiljogebyr}
      getMiljoleveringstyper={getMiljoleveringstyper}
      handleChangeAll={handleChangeAll}
      handleChangeToInitState={() =>
        dispatch(
          handleChangeToInitStateAction(
            "MILJOGEBYRER_TIL_BEHANDLING_FILTER_FORM",
          ),
        )
      }
    />
  );
}
